import { CompositePickerStore } from 'owa-calendar-composite-picker';
import { createStore } from 'satcheljs';

const defaultStore: CompositePickerStore = {
    options: [],
    filteredOptions: [],
    selectedOption: null,
    textFieldValue: '',
    navIndex: 0,
};

export const getStore = createStore('CalendarChannelPickerStore', defaultStore);
